module.exports = __webpack_public_path__ + "static/media/not-found.8ba65c1e.png";